import Swal from "sweetalert2";
import api from "../../../utilities/interseptor";

const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API

export const getBitacoras = (data, setBitacoras) => {
    Swal.fire({
        title: 'Cargando...',
        text: 'Obteniendo datos...',
        allowOutsideClick: false,  // Evita que el modal se cierre haciendo clic fuera
        allowEscapeKey: false,     // Evita que el modal se cierre con la tecla ESC
        didOpen: () => {
            Swal.showLoading();     // Muestra el spinner de carga
        }
    });
    api.get(`${apiUrl}/monitor/bitacoras?fecha_inicio=${data.fecha_inicio}&fecha_fin=${data.fecha_fin}&proveedor=${data.proveedor}&cliente=${data.cliente}&ruta=${data.ruta}&estructura=${data.estructura}&operador=${data.operador}&unidad=${data.unidad}&id_bitacora=${data.id_bitacora}`)
        .then((res) => {
            setBitacoras(res.data)
            Swal.close();

        })
        .catch((error) => {
            Swal.close();
            console.log("error", error);
        })
}